import type { IconProps as Props } from './types';

export const IconChoicesExperience = ({
  className,
  width = '40',
  height = '40',
  stroke = 'currentColor',
  strokeWidth = '2.5',
  fill = 'none',
  ...props
}: Props) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title id="svgTitle">Sparkle Star Icon</title>
      <path
        d="M6 2V10V2ZM2 6H10H2ZM8 30V38V30ZM4 34H12H4ZM22 2L26.572 15.714L38 20L26.572 24.286L22 38L17.428 24.286L6 20L17.428 15.714L22 2Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
